// extracted by mini-css-extract-plugin
export default {"root":"hcpPageHeaderView_root__tROUI","logo":"hcpPageHeaderView_logo__hi7sd","logoNoTitle":"hcpPageHeaderView_logoNoTitle__2oSX4"};